export enum TabsValue {
    POSTS = 'posts',
    COLLECTIONS = 'collections',
    SAVED_COLLECTIONS = 'savedCollections',
    MODERATION = 'moderation',
}

export enum SubcategoriesValue {
    SAVED = 'saved',
    CREATED = 'created',
    MODERATION = 'moderation',
    POSTS = 'posts',
}
